import React from "react";
export function MyMemberships({}) {
    return React.createElement("div", null);
}
